/**
 * @file: withPrompt.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
export const withPrompt = ({
  title,
  message,
  defaultValue,
}: {
  title: string;
  message?: string;
  defaultValue?: string;
}) => {
  return new Promise<string>(resolve => {
    const res = prompt(message ? `${title}\n${message}` : title, defaultValue);
    resolve(res ?? '');
  });
};

export const setDefaultPromptOptions = () => {};
